export enum TabNames {
    Overview = 1,
    Contacts,
    Team,
    'Activity Log',
    Notes,
    Opportunities,
    Buildings,
    Companies,
    Bid
}
